module.exports = __webpack_public_path__ + "img/6875.2f44ee75.jpg";